const insertTooltipText = (el: HTMLElement, text: string, position: string) => {
    const tooltipText = document.createElement('span');
    tooltipText.classList.add('stf-tooltip__text', `stf-tooltip__text--${position}`);
    tooltipText.innerHTML = text;

    el.insertBefore(tooltipText, el.firstChild);
}

const getPosition = (modifiers: Record<string, boolean>): string => {
    let position = 'top-middle'; // Default position
    if (modifiers.topRight) {
        position = 'top-right';
    } else if (modifiers.topLeft) {
        position = 'top-left';
    } else if (modifiers.bottom) {
        position = 'bottom';
    } else if (modifiers.bottomLeft) {
        position = 'bottom-left';
    } else if (modifiers.bottomRight) {
        position = 'bottom-right';
    }

    return position;
}

const vTooltip = {
    mounted: (el: HTMLElement, binding: { value: string, modifiers: Record<string, boolean> }): void => {
        if (binding.value.length === 0) {
            return;
        }

        el.classList.add('stf-tooltip');

        insertTooltipText(el, binding.value, getPosition(binding.modifiers));
    },
    updated: (el: HTMLElement, binding: { value: string, modifiers: Record<string, boolean> }): void => {
        if (binding.value.length === 0) {
            return;
        }

        // Check if the tooltip class is still there, if not re-add it
        if (!el.classList.contains('stf-tooltip')) {
            el.classList.add('stf-tooltip');
        }

        // Update the tooltip text content
        const tooltipText = el.querySelector('.stf-tooltip__text');
        if (tooltipText) {
            tooltipText.innerHTML = binding.value;
        } else {
            insertTooltipText(el, binding.value, getPosition(binding.modifiers));
        }
    },
};

export default vTooltip;
